<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != ''">
            <div class="container-fluid xyz">
                <div class="admin-page-content">
                    <!-- Banner Start -->
                    <app-banner v-show="swipViews == 0" ></app-banner>
                    <!-- Banner End -->
                    <!--page content-->
                    <!-- {{currentTab}} -->
                    <div class="page-title-container">
                        <div v-show="swipViews == 0" class="page-name">{{menuData.menu_title}}</div>
                        <!-- </template> -->
                        <div class="pagebutton" v-if="(user_role == 1 || user_role == 2) && menuData.page_type != '3'">
                            <template v-if="currentTab == 'discussion'">
                                <router-link class="themebutton" v-bind:to="{name: 'DiscussionAddForm'}">
                                    <span>Add New Post</span>
                                </router-link>
                            </template>
                            <template v-else-if="currentTab == 'attachments'">
                                <router-link class="themebutton" v-bind:to="{name: 'AttachmentAddForm'}">
                                    <span>Add New Attachment</span>
                                </router-link>    
                            </template>
                            <template v-else>
                                <router-link class="themebutton" v-bind:to="{name: 'EventAddForm'}">
                                    <span>Add New Date</span>
                                </router-link>    
                            </template>
                        </div>
                        <div v-show="swipViews == 2" class="page-name">{{formTitle}}</div>
                        <div v-show="swipViews == 2" class="pagebutton" >
                            <button class="themebutton btn btn-primary" v-on:click.prevent="buttonBack(2)">
                                <span>Back</span>
                            </button>
                        </div>
                        <div v-show="swipViews == 1" class="page-name">{{selectedEvent.title}}</div>
                        <div v-show="swipViews == 1" class="pagebutton" >
                            <button type="submit" class="mt-2 ml-2 mb-2 btn btn-primary pull-right" v-on:click.prevent="buttonBack(0)">Back</button>
                            <button v-if="user_role == 1 || user_role == 2" type="submit" class="mt-2 ml-2 mb-2 btn btn-primary pull-right" v-on:click.prevent="editEvent(selectedEvent.id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                            <button v-if="user_role == 1 || user_role == 2" type="submit" class="mt-2 ml-2 mb-2 btn btn-primary pull-right" v-on:click.prevent="deleteEvents(selectedEvent.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        </div>
                    </div>
                    <form v-show="swipViews == 2">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="title">Title :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input v-model="title" type="text" class="form-control" id="title" placeholder="Title" maxlength="190">
                                        <span class="help is-danger">{{titleError}}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="colorcode">Calendar Key :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="colorcode"
                                                  name="colorcode"
                                                  id="colorcode"
                                                  label="text"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :filterable="false"
                                                  :options="colorcodeArr"
                                                  placeholder="Select Color Code Type">
                                            <template slot="option" slot-scope="option">
                                                <span class="fa fa-square" :style="'color:'+ option.color_code"></span>
                                                {{ option.text }}
                                            </template>
                                        </v-select>
                                        <span class="help is-danger">{{colorcodeError}}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="keydescription">Key Description :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input v-model="keydescription" type="text" class="form-control" id="keydescription" placeholder="Enter Key Description">
                                        <span class="help is-danger">{{keydescriptionError}}</span>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="description">Description :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea name="description" id="description" rows="3"
                                                  class="form-control no-resize"
                                                  placeholder="Enter Description"
                                                  v-model="description">
                                        </textarea>
                                        <span class="help is-danger">{{descriptionError}}</span>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="status">Status :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="status"
                                                  name="status"
                                                  @input="changedValueStatus()"
                                                  id="status"
                                                  label="text"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :filterable="false"
                                                  :options="statusArr"
                                                  placeholder="Select Status">
                                        </v-select>
                                        <span class="help is-danger">{{statusError}}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="type">Event Type :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="type"
                                                  name="type"
                                                  @input="changedValueType()"
                                                  id="type"
                                                  label="text"
                                                  :clearable="false"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="typeArr"
                                                  placeholder="Select Event Type">
                                        </v-select>
                                        <span class="help is-danger">{{typeError}}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="RecursiveType common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="recursiveType">Recurring Type :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="recursiveType"
                                                  name="recursiveType"
                                                  @input="changedValueRecType()"
                                                  id="recursiveType"
                                                  label="text"
                                                  :clearable="false"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="recursiveTypeArr"
                                                  placeholder="Select Recurring Type">
                                        </v-select>
                                        <span class="help is-danger">{{rectypeError}}</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="WeekDay common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="weekDays">Day Of Week :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="weekDays"
                                                  name="weekDays"
                                                  @input="changedValueWeekDays()"
                                                  id="weekDays"
                                                  label="text"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="weekDaysArr"
                                                  placeholder="Select Day Of Week">
                                        </v-select>
                                        <span class="help is-danger">{{weekDaysError}}</span>
                                    </div>
                                </div>
                                <div class="StartDate common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="startDate" >Start DateTime :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <flat-pickr 
                                            id="StartDate"
                                            v-model="startDate"
                                            :config="configStart"
                                            @on-change="onStartChange"
                                            class="form-control"
                                            placeholder="Select Start Date"
                                            name="startDate"
                                            ></flat-pickr>
                                        <span class="help is-danger">{{startDateError}}</span>
                                    </div>
                                </div>
                                <div class="EndDate common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="endDate" >End DateTime :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <flat-pickr 
                                            id="endDate"
                                            v-model="endDate"
                                            :config="configEnd"
                                            @on-change="onEndChange"
                                            class="form-control"
                                            placeholder="Select End Date"
                                            name="endDate"
                                            ></flat-pickr>
                                        <!--<span class="help is-danger">{{startDateError}}</span>-->
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="userId">Contact Person :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input v-model="userId" type="text" class="form-control" id="duration" placeholder="Contact Person">
                                        <span class="help is-danger">{{contactPersonError}}</span>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="contactEmail">Contact Email :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                                        <span class="help is-danger">{{contactEmailError}}</span>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="contactNumber">Contact Number :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number">
                                        <span class="help is-danger">{{contactNumberError}}</span>
                                    </div>
                                </div>
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label" for="dropzone">Attachments :</div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <vue-dropzone
                                            ref="dropzone" 
                                            id="dropzone" 
                                            :options="dropzoneOptions"
                                            @vdropzone-success = "uploadDocument"
                                            @vdropzone-removed-file="removedSelectedFile"
                                            @vdropzone-error="fileError"
                                            @vdropzone-file-added="fileAdd"
                                            @vdropzone-total-upload-progress="progressOfUload"
                                            :useCustomSlot=true
                                            >
                                            <div class="dropzone-custom-content">
                                                <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                <div class="subtitle">(Select files from your computer.)</div>
                                            </div>
                                        </vue-dropzone>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-12 paddingleft0">
                                    <div class="form-label"><span>{{createdByTitle}}</span> : {{createdBy}}</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <input id="CancelSocialMedia" type="submit" value="Cancel" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack(2)">
                                    <input id="addSocialMediaBtn" type="submit" value="Save" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEvent()">
                                </div>

                            </div>
                        </div>
                    </form>
                    <template v-if="showMenu" v-for="(menuData, index) in $store.getters.menuArr" >
                        <template v-if="typeof(menuData.sub_menu) != 'undefined'">
                            <template v-if="menuData.sub_menu.length > 0 && menuData.slug == menuParentSlug">
                                <swiper v-bind:key="index" class="sales-programs-menu" :options="swiperOptionSubMenu" ref="mySwiper">
                                    <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                        <template v-if="subMenuData.parent_id != null">
                                            <template v-if="subMenuData.url != null && subMenuData.url != ''">
                                                <swiper-slide v-bind:key="'slide_'+index1">
                                                    <a :key="index1" :href="subMenuData.url" target="_blank">
                                                        <span :class="'spm-menu ' + subMenuData.icon_url"></span>
                                                        <template v-if="subMenuData.menu_title.length >= 38">
                                                            <p v-b-tooltip.hover :title="subMenuData.menu_title">{{stringTrim(subMenuData.menu_title,42)}}</p>
                                                        </template>
                                                        <template v-else>
                                                            <p>{{subMenuData.menu_title}}</p>
                                                        </template>
                                                    </a>
                                                </swiper-slide>
                                            </template>
                                            <template v-else>
                                                <swiper-slide v-bind:key="'slide_'+index1">
                                                    <router-link :key="index1" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        <span :class="'spm-menu ' + subMenuData.icon_url"></span>
                                                        <template v-if="subMenuData.menu_title.length >= 38">
                                                            <p v-b-tooltip.hover :title="subMenuData.menu_title">{{stringTrim(subMenuData.menu_title,42)}}</p>
                                                        </template>
                                                        <template v-else>
                                                            <p>{{subMenuData.menu_title}}</p>
                                                        </template>
                                                    </router-link>
                                                </swiper-slide>
                                            </template>
                                        </template>
                                    </template>
                                    <!--<div class="swiper-pagination" slot="pagination"></div>-->
                                </swiper>
                            </template>
                        </template>
                    </template>

                    <template v-if='menuData.page_type != "3"'>
                        <div class="internal-container" v-show="!show_Group_Data">
                            <div class="row pageFilters"> <!--page filter-->
                                <template v-if="pageType.length >= 2">
                                    <template v-if="currentTab == 'discussion'">
                                        <div class="col-sm-12 col-md-4 customTab">
                                            <div class="row">
                                                <template v-for="(text, index) in pageType">
                                                    <template v-if="text == 1">
                                                        <button id="" type="button" class="btnDiscussion btn btn-primary pull-left" v-on:click.prevent="changeTab('discussion')">Discussion</button>
                                                    </template>
                                                    <template v-else-if="text == 2">
                                                        <button id="" type="button" class="btnAttachment ml-2 btn btn-outline-primary pull-left" v-on:click.prevent="changeTab('attachments')">Attachment</button>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-sm-12 col-md-3 customTab">
                                            <div class="row">
                                                <template v-for="(text, index) in pageType">
                                                    <template v-if="text == 1">
                                                        <button id="" type="button" class="btnDiscussion btn btn-outline-primary pull-left" v-on:click.prevent="changeTab('discussion')">Discussion</button>
                                                    </template>
                                                    <template v-else-if="text == 2">
                                                        <button id="" type="button" class="btnAttachment ml-2 btn btn-primary pull-left" v-on:click.prevent="changeTab('attachments')">Attachment</button>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </template>

                                <div v-show="currentTab == 'discussion'" class="col-sm-12 col-md-3 serch-discussion-tab">
                                    <input type="text" class="form-control" id="discussionSearch" placeholder="Search Discussion" v-model="discussionSearch" name="discussionSearch" />
                                </div>

                                <div v-show="currentTab == 'attachments'" class="col-sm-12 col-md-2 serch-attachment-tab">
                                    <input type="text" class="form-control" id="attachmentSearch" placeholder="Search Attachments" v-model="attachmentSearch" name="attachmentSearch" />
                                </div>

                                <div v-show="currentTab == 'savethedate'" class="col-sm-12 col-md-4 serch-event-tab">
                                    <input type="text" class="form-control" id="savetheDateSearch" placeholder="Search Event" v-model="saveDateSearch" name="saveDateSearch" />
                                </div>

                                <div v-show="currentTab == 'discussion'" class="col-sm-6 col-md-5 sortByField">
                                    <label>Sort By:</label>
                                    <v-select class="input-field-si" v-model="discussionSort" 
                                              name="discussionSort"
                                              placeholder="Select field for sorting"
                                              label="text"
                                              :options="discussionSortArr"
                                              :clearable=false>
                                    </v-select>
                                </div>
                                <div v-show="currentTab == 'attachments'" class="col-sm-6 col-md-5 sortByField">
                                    <label>Sort By:</label>
                                    <v-select class="input-field-si" v-model="attachmentSort" 
                                              name="attachmentSort" 
                                              placeholder="Select field for sorting"
                                              label="text"
                                              :options="attachmentSortArr"
                                              :clearable=false>
                                    </v-select>
                                </div>
                                <div v-show="currentTab == 'savethedate'" class="col-sm-6 col-md-5 sortByField">
                                    <label>Sort By:</label>
                                    <v-select class="input-field-si" v-model="savethedateSort" 
                                              name="savethedateSort" 
                                              placeholder="Select field for sorting"
                                              label="text"
                                              :options="savethedateSortArr"
                                              :clearable=false>
                                    </v-select>
                                </div>
                                <div v-show="currentTab == 'attachments'" class="col-sm-12 col-md-2">
                                    <button v-if="is_Grid == true" class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon2.png"></button>
                                    <button v-if="is_Grid == false"  class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon1.png"></button>
                                    <button v-if="is_Grid == false" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon2.png"></button>
                                    <button v-if="is_Grid == true" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon1.png"></button>
                                </div>
                            </div>
                        </div> <!--page filter-->
                    </template>
                    <template v-if='menuData.page_type != "3"'>
                        <div class="internal-container" v-show="!show_Group_Data">
                            <div v-show="currentTab == 'discussion'" id="discussionData">
                                <template v-if="discussionData.total_rows > 0">
                                    <template v-for="(data, index) in discussionData.discussions">
                                        <div v-bind:key="index" class="bulletin-board-listing">
                                            <div class="bullentin-board-listing-top">
                                                <div v-on:click="viewDetails(data.id)" class="bullentin-question">
                                                    {{data.title}}
                                                </div>
                                                <div v-if="user_role == 1 || user_role == 2">
                                                    <b-navbar>
                                                        <b-navbar-nav>
                                                            <b-nav-item-dropdown>
                                                                <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'DiscussionEditForm', params:{id:data.id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                                <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.id, 'discussion')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>                                                    <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                            </b-nav-item-dropdown>
                                                        </b-navbar-nav>
                                                    </b-navbar>
                                                </div>
                                            </div>
                                            <div class="bulletin-view">
                                                <div class="avtarimg">
                                                    <div class="username-letter" >{{getInitials(data.updated_name)}}</div>
                                                </div>
                                                <div class="bulletin-view-details">
                                                    <div class="useravtarname">{{formatString(data.updated_name)}}</div>
                                                    <div class="bullentininfo">{{utcToLocal(data.updated_at,'D MMMM, YYYY')}} &nbsp; | &nbsp;{{utcToLocal(data.updated_at,'hh:mm A')}}</div>
                                                    <div class="bullentintext">
                                                        <span v-html="stringTrim(data.description,500)" v-linkified:options="{ className: '' }"></span>
                                                        <template v-if='data.documents.length > 0'>
                                                            <h5>Corresponding Files</h5>
                                                            <div class="attachmentContainer">
                                                                <template>
                                                                    <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                                        <template v-for="(doc, index1) in data.documents">
                                                                            <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                                                <swiper-slide>
                                                                                    <img :src="doc.document" :title="doc.document_name" @click="openGallery(data.documents,index1)">
                                                                                    <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                    <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                                </swiper-slide>
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                                <swiper-slide>
                                                                                    <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                                                </swiper-slide>
                                                                                <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                                <swiper-slide>
                                                                                    <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                                                </swiper-slide>
                                                                                <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                                <swiper-slide>
                                                                                    <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                                                </swiper-slide>
                                                                                <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                                <swiper-slide>
                                                                                    <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                                                </swiper-slide>
                                                                                <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                            </template>
                                                                            <template v-else>
                                                                                <swiper-slide>
                                                                                    <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                                                </swiper-slide>
                                                                                <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                                <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                            </template>
                                                                        </template>
                                                                    </swiper>
                                                                </template>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                    </template>
                                    <div v-if="discussionData.total_rows > discussionData.per_page" class="pagination-container">
                                        <b-pagination align="center" 
                                                      prev-text="‹ Previous"
                                                      next-text="Next ›" :total-rows="discussionData.total_rows" v-model="discussionCurrentPage" :per-page="discussionData.per_page"></b-pagination>
                                    </div>
                                    <b-modal size="lg" class="gallery_modal" id="modal1" @cancel="onCancel('main')" ref="myModalRef" hide-footer :hide-header=true>
                                             <img class="w-100 mb-3" :src="viewImage">
                                        <div class="clearfix"></div>
                                        <div class="image-arrows customIconModelFooter clearfix">
                                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                                        </div>
                                    </b-modal>
                                </template>
                                <template v-else>
                                    <div class="">
                                        <div class="forms-container">
                                            <div class="error-template">
                                                <div class="error-details no-data-found-error">
                                                    No discussions found...!!!
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </template>
                            </div>
                            <!-- display grid view single or multiple grid -->
                            <div v-show="currentTab == 'attachments'" id="attachemntData">
                                <template v-if="attachmentData.total_rows > 0">
                                    <div class="internal-listing-container">
                                        <template v-if="is_Grid">
                                            <template v-for="(data, index) in attachmentData.attachments">
                                                <template v-if="data.is_group == 0">
                                                    <div class="single-listing">
                                                        <div class="upload-doc-img">
                                                            <template v-if="data.data[0].upload_type == 'url'">
                                                                <img src="/static/images/link-icon.png" class="link-icon">
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="data.data[0].documents.length > 0">
                                                                    <template v-for="(doc, index1) in data.data[0].documents">
                                                                        <template v-if="doc.doc_extension.toLowerCase() == 'gif'">
                                                                            <img src="/static/images/link-icon.png" class="link-icon">
                                                                        </template>
                                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                            <img src="/static/images/doc-icon.png" class="link-icon">
                                                                        </template>
                                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                            <img src="/static/images/xl-icon.png" class="link-icon">
                                                                        </template>
                                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                            <img src="/static/images/ppt-icon.png" class="link-icon">
                                                                        </template>
                                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                            <img src="/static/images/pdf-icon.png" class="link-icon">
                                                                        </template>
                                                                        <template v-else>
                                                                            <img src="/static/images/link-icon.png" class="link-icon">
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <img src="/static/images/link-icon.png" class="link-icon">
                                                                </template>
                                                            </template>
                                                        </div>
                                                        <div class="single-listing-text">
                                                            <template v-if="data.data[0].upload_type == 'url'">
                                                                <a :href="data.data[0].url" v-b-tooltip.hover :title="data.data[0].title" target="_blank">{{stringTrim(data.data[0].title,60)}}</a>
                                                            </template>
                                                            <template v-else>
                                                                <span v-b-tooltip.hover :title="data.data[0].title">{{stringTrim(data.data[0].title,60)}}</span>
                                                            </template>
                                                        </div>
                                                        <template v-if="data.data[0].upload_type != 'url'">
                                                            <template v-for="(doc, index1) in data.data[0].documents">
                                                                <div class="download">
                                                                    <template v-if="doc.doc_extension.toLowerCase() == 'mp4' || doc.doc_extension.toLowerCase() == 'mpeg' || doc.doc_extension.toLowerCase() == 'mkv'">
                                                                        <div style="margin-top:-15px;margin-left:25px;" data-backdrop="static" data-keyboard="false" data-toggle="modal" data-target="#videoPlayModal" @click="setVideoFilePath(doc.document)">
                                                                            <img width=52px height=52px src="/static/images/video-play.png" class="link-icon">
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <a :href="doc.document" target="_blank">Download</a>
                                                                    </template>
                                                                </div>
                                                            </template>
                                                        </template>
                                                        <div class="listing-user-info">
                                                            <div v-if="user_role == 1 || user_role == 2">
                                                                <b-navbar>
                                                                    <b-navbar-nav>
                                                                        <b-nav-item-dropdown>
                                                                            <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.data[0].id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                                            <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.data[0].id, 'attachment')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>
                                                                            <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                                        </b-nav-item-dropdown>
                                                                    </b-navbar-nav>
                                                                </b-navbar>
                                                            </div>
                                                            <div class="listing-user">{{formatString(data.data[0].updated_name)}}</div>
                                                            <div class="listing-block-info">
                                                                <div class="listing-date">{{utcToLocal(data.data[0].updated_at,'MM/DD/YYYY')}}</div>
                                                                <div class="listing-time">{{utcToLocal(data.data[0].updated_at,'hh:mm A')}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="single-listing"  v-on:click="showGroupDiv(data.group_id)">
                                                        <div class="upload-doc-img">
                                                            <img src="/static/images/folder-icon.png" class="link-icon">
                                                        </div>
                                                        <div class="single-listing-text">
                                                            <span v-b-tooltip.hover :title="data.group_name">{{stringTrim(data.group_name,60)}}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <div class="three-column-listing">
                                                <template v-for="(data, index) in attachmentData.attachments">
                                                    <template v-if="data.is_group == 0">
                                                        <div v-bind:key="index" class="three-column-listing-block">
                                                            <div class="upload-doc-img">
                                                                <template v-if="data.data[0].upload_type == 'url'">
                                                                    <img src="/static/images/link-icon.png">
                                                                </template>
                                                                <template v-else>
                                                                    <template v-for="(doc, index1) in data.data[0].documents">
                                                                        <div v-bind:key="index1">
                                                                            <template v-if="doc.doc_extension.toLowerCase() == 'gif'">
                                                                                <img src="/static/images/link-icon.png">
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                                <img src="/static/images/doc-icon.png">
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                                <img src="/static/images/xl-icon.png">
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                                <img src="/static/images/ppt-icon.png">
                                                                            </template>
                                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                                <img src="/static/images/pdf-icon.png">
                                                                            </template>
                                                                            <template v-else>
                                                                                <img src="/static/images/link-icon.png">
                                                                            </template>
                                                                        </div>
                                                                    </template>
                                                                </template>
                                                            </div>
                                                            <div class="three-column-right">
                                                                <div class="three-column-right-container">
                                                                    <div v-if="user_role == 1 || user_role == 2">
                                                                        <b-navbar>
                                                                            <b-navbar-nav>
                                                                                <b-nav-item-dropdown>
                                                                                    <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.data[0].id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                                                    <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.data[0].id, 'attachment')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>
                                                                                    <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                                                </b-nav-item-dropdown>
                                                                            </b-navbar-nav>
                                                                        </b-navbar>
                                                                    </div>
                                                                    <span>
                                                                        <template v-if="data.data[0].upload_type == 'url'">
                                                                            <span v-if="data.data[0].title.length <= 20" v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                            <span v-else v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span v-if="data.data[0].title.length <= 20" v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                            <span v-else v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                        </template>
                                                                    </span>
                                                                    <div class="listing-block-info">
                                                                        <div class="listing-date">{{utcToLocal(data.data[0].updated_at,'MM/DD/YYYY')}}</div>
                                                                        <div class="listing-time">{{utcToLocal(data.data[0].updated_at,'hh:mm A')}}</div>
                                                                    </div>
                                                                </div>
                                                                <template v-if="data.data[0].upload_type != 'url'">
                                                                    <template v-for="(doc, index1) in data.data[0].documents">
                                                                        <a v-bind:key="index1" :href="doc.document" class="downloadnow" target="_blank">Download Now!</a>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <a :href="data.data[0].url" class="downloadnow" target="_blank">Visit Now!</a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div v-bind:key="index" class="three-column-listing-block" v-on:click="showGroupDiv(data.group_id)">
                                                            <div class="upload-doc-img">
                                                                    <img src="/static/images/folder-icon.png">
                                                            </div>
                                                            <div class="three-column-right">
                                                                <div class="three-column-right-container">
                                                                    <span>
                                                                        <span v-if="data.group_name <= 20" v-b-tooltip.hover.topright :title="data.group_name">{{stringTrim(data.group_name,20)}}</span>
                                                                        <span v-else v-b-tooltip.hover.topright :title="data.group_name">{{stringTrim(data.group_name,20)}}</span>
                                                                    </span>
                                                                    <div class="listing-block-info">
                                                                        <div class="listing-date">&nbsp;</div>
                                                                        <div class="listing-time">&nbsp;</div>
                                                                    </div>
                                                                </div>
                                                                <template>
                                                                    &nbsp;
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </div>
                                        </template>
                                        <div v-if="attachmentData.total_rows >= attachmentData.per_page">
                                            <b-pagination align="center" 
                                                          prev-text="‹ Previous"
                                                          next-text="Next ›" :total-rows="attachmentData.total_rows" v-model="attachmentCurrentPage" :per-page="attachmentData.per_page"></b-pagination>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="">
                                        <div class="forms-container">
                                            <div class="error-template">
                                                <div class="error-details no-data-found-error">
                                                    No attachments found...!!!
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </template>
                            </div>
                            <div v-show="currentTab == 'savethedate'" id="savethedateDate">
                                <template v-if="saveTheDateData.total_rows > 0">
                                    <div class="internal-container">
                                        <template v-for="(data, index) in saveTheDateData.saveTheDateData">
                                            <div v-bind:key="index" class="std-listing">
                                                <div class="dateview">
                                                    <strong title="Date">{{data.eventDateSplit}}</strong><br/> {{data.eventDateMonthName}}
                                                </div>

                                                <div v-bind:key="index" class="listing-user-info">
                                                    <div v-if="user_role == 1 || user_role == 2">
                                                        <b-navbar>
                                                            <b-navbar-nav>
                                                                <b-nav-item-dropdown>
                                                                    <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'EventEditForm', params:{id:data.id}}">Edit</router-link>
                                                                    <button class="btn btn-primary pull-right" v-on:click.prevent="deleteEvent(data.id)">Delete</button>
                                                                    <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                                </b-nav-item-dropdown>
                                                            </b-navbar-nav>
                                                        </b-navbar>
                                                    </div>
                                                </div>

                                                <div class="std-info">
                                                    <div class="std-que-ans-container">
                                                        <div class="question">{{data.title}}</div>
                                                        <div class="answers">{{data.description}}</div>
                                                    </div>
                                                    <div class="download-attachments">
                                                        <span>Download Attachments:</span>
                                                        <template v-for="(doc, index1) in data.documents">
                                                            <template v-if="doc.doc_extension.toLowerCase() == 'gif'">
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/link-icon.png" class="link-icon"></a>
                                                            </template>
                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/doc-icon.png" class="link-icon"></a>
                                                            </template>
                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/xl-icon.png" class="link-icon"></a>
                                                            </template>
                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                            </template>
                                                            <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                            </template>
                                                            <template v-else>
                                                                <a :href="doc.document" target="_blank"><img v-bind:key="index1" src="/static/images/link-icon.png" class="link-icon"></a>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if="saveTheDateData.total_rows > saveTheDateData.per_page" class="bulletin-board-listing">
                                            <b-pagination align="center" 
                                                          prev-text="‹ Previous"
                                                          next-text="Next ›" :total-rows="saveTheDateData.total_rows" v-model="saveTheDateCurrentPage" :per-page="saveTheDateData.per_page"></b-pagination>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="">
                                        <div class="forms-container">
                                            <div class="error-template">
                                                <div class="error-details no-data-found-error">
                                                    No dates found...!!!
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </template>
                            </div>
                        </div>
                        <template v-if="show_Group_Data">
                            <show-group-data 
                                v-bind:menuSlug=menuSlug 
                                v-bind:selected_group_id=selectedAttachmentGroup 
                                v-bind:attachmentDataOfGroupChild=selectedGroupAttachments 
                                v-bind:key=selectedGroupAttachments.group_name
                                v-bind:user_role=user_role  
                                :is_Grid_Child=is_Grid 
                                :backButtonClicked="clickedBackFromChild"
                                :loadAttachmentFrom="loadAttachmentFromChild"
                                />
                        </template>
                    </template>
                    <template v-else>
                        <div class="internal-container" >
                            <div v-show="swipViews == 1" id="discussionData">
                                <div v-bind:key="index" class="bulletin-board-listing">
                                    <div class="bulletin-view">
                                        <div class="bullentininfo">Event Date : 
                                            <span v-show="selectedEvent.recursive_type != null" class="">{{selectedEvent.eventdate}} {{selectedEvent.eventtime}}</span>
                                            <span v-show="selectedEvent.recursive_type == null" class="">{{formatDateTime(selectedEvent.start_date_time,'D MMMM, YYYY')}} &nbsp; | &nbsp;{{formatDateTime(selectedEvent.start_date_time,'hh:mm A')}}</span>
                                        </div>
                                        <div class="bullentintext">
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12 ">
                                                    <span>Event Type : {{selectedEvent.mm_title}}</span>
                                                </div>
                                                <div v-show="selectedEvent.contact_person != ''" class="col-md-6 col-sm-12 ">
                                                    <span>Contact Person : {{selectedEvent.contact_person}}</span>
                                                </div>
                                                <div v-show="selectedEvent.contact_email != ''" class="col-md-6 col-sm-12 ">
                                                    <span>Contact Email : <a :href="'mailto:'+selectedEvent.contact_email">{{selectedEvent.contact_email}}</a></span>
                                                </div>
                                                <div v-show="selectedEvent.contact_number != ''" class="col-md-6 col-sm-12 ">
                                                    <span>Contact Number : <a :href="'tel:'+selectedEvent.contact_number" target="_blank">{{selectedEvent.contact_number}}</a></span>
                                                </div>
                                                <div v-if="user_role == 1 || user_role == 2" class="col-md-6 col-sm-12 ">
                                                    <span>Status : {{formatString(selectedEvent.status)}}</span>
                                                </div>
                                                <div v-show="selectedEvent.key_description != ''" class="col-md-6 col-sm-12 ">
                                                    <span>Key Description : {{selectedEvent.key_description}}</span>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <br/>
                                            <div v-show="selectedEvent.description != ''">
                                                <span >Description : </span>
                                                <div class="clearfix"></div>
                                                <span v-html="selectedEvent.description" v-linkified:options="{ className: '' }"></span>
                                                <div class="clearfix"></div>
                                            </div>
                                            <template v-if='selectedAttachments > 0'>
                                                <h5>Corresponding Files <button type="button" id="DownloadAll" class="btn btn-primary pull-right" v-on:click.prevent="downloadAllAttachments(selectedEvent.id)">Download All</button></h5>
                                                <div class="attachmentContainer">
                                                    <template>
                                                        <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                            <template v-for="(doc, index1) in selectedEvent.attachments">
                                                                <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                                    <swiper-slide>
                                                                        <img :src="doc.url" @click="openGallery(selectedEvent.attachments,index1)">
                                                                    </swiper-slide>
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                    <swiper-slide>
                                                                        <a :href="doc.url" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                                    </swiper-slide>
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                    <swiper-slide>
                                                                        <a :href="doc.url" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                                    </swiper-slide>
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                    <swiper-slide>
                                                                        <a :href="doc.url" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                                    </swiper-slide>
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                    <swiper-slide>
                                                                        <a :href="doc.url" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                                    </swiper-slide>
                                                                </template>
                                                                <template v-else>
                                                                    <swiper-slide>
                                                                        <a :href="doc.url" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                                    </swiper-slide>
                                                                </template>
                                                            </template>
                                                        </swiper>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>

                                    </div>
                                </div>
                                <b-modal size="lg" class="gallery_modal" id="modal1" @cancel="onCancel('main')" ref="myModalRef" hide-footer :hide-header=true>
                                         <img class="w-100 mb-3" :src="viewImage">
                                    <div class="clearfix"></div>
                                    <div class="image-arrows customIconModelFooter clearfix">
                                        <button type="button" class="ml-2 btn btn-primary pull-right" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                                        <button type="button" class="ml-2 btn btn-primary pull-right" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                                        <button class="ml-2 btn btn-primary pull-right" type="button"  v-on:click="downloadImage(viewImage)"><i class="fa fa-download" aria-hidden="true"></i></button>
                                    </div>
                                </b-modal>
                            </div>
                            <div v-show="swipViews == 0" id="calendar">
                                <div class="mb-2 keysContainer" v-if="keysArr.length > 0"><strong>Keys</strong></div>
                                <div class="mb-4 keysContainer">
                                    <template v-for="(key, index) in keysArr">
                                        <template v-if='key.is_view == 1'>
                                            <button 
                                                :key='key.value+"_"+key.is_view'
                                                @click="changeVisible(key.value)"
                                                :id="'key_'+key.value" class="mt-2 mr-3 btn btn-success pull-left" 
                                                :title='key.text + " is visible"'
                                                :style="'color:#FFFFFF;background:'+ key.color_code + ';border:'+ key.color_code + '; opacity:1;'"
                                                >{{key.text}}</button>    
                                        </template>
                                        <template v-else>
                                            <button 
                                                :key='key.value+"_"+key.is_view'
                                                @click="changeVisible(key.value)"
                                                :id="'key_'+key.value" class="mt-2 mr-3 btn btn-success pull-left" 
                                                :title='key.text + " is not visible"'
                                                :style="'color:#FFFFFF;background:'+ key.color_code+';border:'+ key.color_code+'; opacity:0.5;'"
                                                >{{key.text}}</button>    
                                        </template>
                                        <!--<span class="mr-3">
                                            <i class="fa fa-square" :style="'color:'+ key.color_code" aria-hidden="true"></i> {{key.text}}
                                        </span>-->
                                    </template>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="fullCalendarView">
                                    <div class="callendarButtons">
                                        <div class="nevCalendar">
                                            <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                            <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                                        </div>
                                        <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                                        <button id="backToCalendar" @click="backToCalendar()" class="btn btn-success pull-right" style="display: none;margin-left: 5px; padding: 7px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button>
                                        <!--Search-->
                                        <!--<form class="search-form" role="search">-->
                                        <div class="btn btn-success form-group pull-right searchBtn" id="search" @click="searchBtnClick()">
                                            <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                                            <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                                            <span class="search-label"><i class="fa fa-search"></i></span>
                                        </div>
                                    </div>
                                    <full-calendar 
                                        id="EVcalendar" 
                                        :events="display_events" 
                                        :config="config" 
                                        @day-click="dayClick" 
                                        @event-selected="eventSelected" 
                                        ref="EVcalendar">
                                    </full-calendar>
                                    <!--Event List-->
                                    <div id="list" class="list-group">
                                        <template v-for="(text, index) in eventList">
                                            <button @click="loadEvent(text.id)" type="button" class="list-group-item list-group-item-action">{{text.title}}
                                                <span v-show="text.recursive_type != null" class="pull-right">{{text.eventdate}}</span>
                                                <span v-show="text.recursive_type == null" class="pull-right">{{formatDateTime(text.start_date_time,'D MMMM, YYYY')}} &nbsp; | &nbsp;{{formatDateTime(text.start_date_time,'hh:mm A')}}</span>
                                            </button>
                                        </template>
                                    </div>
                                    <!--End Event List-->    
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="medium-modal">
                <b-modal ref="videoPlayModal" id="modallg" size="lg" class="modal-section" :hide-footer="true" @hidden="closeModalEvent">
                    {{ videoFilePath }}
                    <video src="" id="video-container" width="100%" controls></video>
                </b-modal>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <a href="#" id="scroll" title="Scroll to Top" style="display: none;">Top<span></span></a>
        <app-footer></app-footer>
    </div>
</template>

<script>
    var exten = ['gif', 'jpg', 'jpeg', 'png'];
    import Vue from 'vue';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import Footer from "@/components/partials/Footer";
    import ShowGroupData from "@/components/ShowGroupData";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import { Button } from 'bootstrap-vue/es/components';
    import BannerComponent from '@/components/Banner/BannerComponents';
    import { Pagination } from 'bootstrap-vue/es/components';
    import vSelect from 'vue-select';
    import moment from 'moment';

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import tinymce from 'vue-tinymce-editor';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    export default {
        name: 'CommonPage',
        components: {
            'v-select': vSelect,
            'app-footer': Footer,
            'show-group-data': ShowGroupData,
            'app-banner': BannerComponent,
            'full-calendar': FullCalendar,
            'datePicker': datePicker,
            'tinymce': tinymce,
            'vueDropzone': vue2Dropzone,
            swiper,
            swiperSlide,
            flatPickr,
        },
        mixins: [commonMixins],
        data() {
            return {
                strAutoPlay: 'play',
                videoFilePath: '',
                title: '',
                titleError: '',
                keydescription: '',
                keydescriptionError: '',
                description: '',
                descriptionError: '',
                colorcode: "",
                keysArr: [],
                colorcodeArr: [],
                colorcodeError: '',
                swipViews: 0,
                editEventID: 0,
                display_events: [],
                events: [],
                startDateFrom: 0,
                endDateTo: 0,
                startDateError: '',
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],
                statusError: '',
                type: {value: 'normal', text: 'Normal'},
                typeArr: [
                    {value: 'normal', text: 'Normal'},
                    {value: 'recursive', text: 'Recurring'}
                ],
                typeError: '',
                recursiveType: {value: 'monthly', text: 'Monthly'},
                recursiveTypeArr: [
                    {value: 'weekly', text: 'Weekly'},
                    {value: 'monthly', text: 'Monthly'},
                    {value: 'yearly', text: 'Annual'}
                ],
                rectypeError: '',
                weekDays: {value: '1', text: 'Monday'},
                weekDaysArr: [
                    {value: '1', text: 'Monday'},
                    {value: '2', text: 'Tuesday'},
                    {value: '3', text: 'Wednesday'},
                    {value: '4', text: 'Thursday'},
                    {value: '5', text: 'Friday'},
                    {value: '6', text: 'Saturday'},
                    {value: '7', text: 'Sunday'},
                ],
                weekDaysError: '',
                startDate: '',
                configStart: {
                    wrap: false, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    //minDate: new Date(),
                    maxDate: null
                            //locale: Hindi, // locale for this instance only          
                },
                startDateError: '',
                endDate: '',
                configEnd: {
                    wrap: false, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    minDate: null
                            //locale: Hindi, // locale for this instance only          
                },
                endDateError: '',
                userId: '',
                contactPersonError: '',
                contactEmail: '',
                contactEmailError: '',
                contactNumber: '',
                contactNumberError: '',
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
                detailFromEmailId: 0,
                /**/
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                                // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                                // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                                //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                createdByTitle: '',
                createdBy: '',
                formTitle: "Add Calender Entry",
                eventList: [],
                searchEvents: '',
                showMenu:true,
                config: {
                    /*'weekends': false,*/
                    defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "Calendaer Entries Not Available",
                    eventRender: (event, element, view) => {
                        element.prop('id', moment(event.start, "YYYY-MM-DD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss") + "_" + event.id);
                        element.prop('style', element.attr("style") + ';cursor: pointer;');
                        var eventTitle = "Title : " + event.title + "\n";
                        if (event.contact_person.trim() != '') {
                            eventTitle += "Contact Person : " + event.contact_person.trim() + "\n";
                        }
                        if (event.contact_email.trim() != '') {
                            eventTitle += "Contact Email : " + event.contact_email.trim() + "\n";
                        }
                        if (event.contact_number.trim() != '') {
                            eventTitle += "Contact Number : " + event.contact_number.trim() + "\n";
                        }
                        if (event.key_description.trim() != '') {
                            eventTitle += "Key Description : " + event.key_description.trim() + "\n";
                        }
                        element.prop('title', eventTitle);
                    },
                    eventClick: (event) => {
                        this.selectedEvent = event;
                        //this.showModel();
                        this.selectedAttachments = this.selectedEvent.attachments.length;
                        this.showMenu = false;
                        this.showDetails();
                    },
                    dayClick: (date, jsEvent, view) => {
                        if (this.user_role == 1 || this.user_role == 2) {
                            this.showMenu = false;
                            this.swipViews = 2;
                            this.editEventID = 0;
                            this.startDate = (moment(date).format("YYYY-MM-DD")) + " 00:00:00";
                            this.endDate = (moment(date).format("YYYY-MM-DD")) + " 23:59:59";
                            $("#addSocialMediaBtn").val("Save");
                            this.createdByTitle = 'Created By';
                            this.formTitle = 'Add Calender Entry';
                            this.scrollToTop();
                            /*console.log(this.startDateFrom);
                             console.log(jsEvent);
                             console.log(view);*/
                        }
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    }
                },
                selectedEvent: {},
                selectedAttachments: 0,
                //user_role: 0,
                swiperOptionSubMenu: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1700: {
                            slidesPerView: 4.2
                        },
                        1600: {
                            slidesPerView: 3.9
                        },
                        1500: {
                            slidesPerView: 3.6
                        },
                        1400: {
                            slidesPerView: 3.4
                        },
                        1300: {
                            slidesPerView: 3.2
                        },
                        1200: {
                            slidesPerView: 2.8
                        },
                        1000: {
                            slidesPerView: 2.2
                        },
                        667: {
                            slidesPerView: 2.2
                        },
                        480: {
                            slidesPerView: 1.5
                        },
                        360: {
                            slidesPerView: 1.3
                        }
                    }
                },

                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.5
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 8.5
                        },
                        1000: {
                            slidesPerView: 7.5
                        },
                        667: {
                            slidesPerView: 5.5
                        },
                        480: {
                            slidesPerView: 3.5
                        },
                        360: {
                            slidesPerView: 3.4
                        }
                    }
                },

                lightboxImages: [],
                viewImage: '',
                index: 0,
                is_Grid: true,
                discussionSort: {text: "Newest First", value: 'desc'},
                attachmentSort: {text: "Newest First", value: 'desc'},
                savethedateSort: {text: "Newest First", value: 'desc'},
                attachmentSortArr: [{
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }],
                discussionSortArr: [{
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }],
                savethedateSortArr: [{
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }],
                menu_id: 0,
                menuSlug: "",
                discussionSearch: "",
                attachmentSearch: "",
                saveDateSearch: "",
                discussionCurrentPage: 1,
                attachmentCurrentPage: 1,
                saveTheDateCurrentPage: 1,
                discussionData: [],
                attachmentData: [],
                saveTheDateData: [],
                menuArr: [],
                is_SubMenu: false,
                commentData: "",
                comment_err_msg: "",
                groupAttachmentsResult:[],
                show_Group_Data: false,
                selectedGroupAttachments:{
                    per_page:12,
                    total_rows:7,
                    attachments:[],
                    group_name:[],
                },
                selectedAttachmentGroup:0
            }
        },
        watch: {
            '$route': function () {
                var self = this;
                self.swipViews = 0;
                self.getMenuSlug();
                /*Added By Afrar*/
                self.show_Group_Data = false;
                $("html, body").animate({scrollTop: 0}, 10);
            },
            searchEvents: function (searchEvents) {
                var self = this;
                self.searchEvent();
            },
            menuData: {
                handler(object) {
                    var self = this;
                    if (object.page_type == 3) {
                        self.loadCalendarEvents();
                        self.loadMeetingType();
                        //console.log("yes " + object.page_type);
                    }
                },
                deep: true
            },
            type: function (type) {
                var self = this;
                var typ = (type === null || typeof type.value === "undefined" || type.value === null || type.value == '') ? '' : type.value;
                /*console.log("typ : " + typ);*/
                if (typ == 'recursive') {
                    $('.RecursiveType').show();
                    /*$('.EndDate').hide();*/
                } else {
                    self.recursiveType = {value: 'monthly', text: 'Monthly'};
                    self.weekDays = {value: '1', text: 'Monday'};
                    $('.RecursiveType').hide();
                    /*$('.EndDate').show();*/
                    $('.StartDate').show();
                    $('.WeekDay').hide();
                }
            },
            recursiveType: function (recursiveType) {
                var self = this;
                var typ = (recursiveType === null || typeof recursiveType.value === "undefined" || recursiveType.value === null || recursiveType.value == '') ? '' : recursiveType.value;
                if (typ == 'monthly' || typ == 'yearly') {
                    $('.StartDate').show();
                    $('.WeekDay').hide();
                    $('.EndDate').show();
                } else {
                    $('.WeekDay').show();
                    $('.StartDate').hide();
                    $('.EndDate').hide();
                }
            },
            discussionCurrentPage: function () {
                var self = this;
                self.loadSalesPost();
            },
            attachmentCurrentPage: function () {
                var self = this;
                self.loadSalesAttachment();
            },
            saveTheDateCurrentPage: function () {
                var self = this;
                self.loadSaveTheDateDoc();
            },
            attachmentSort: function () {
                var self = this;
                self.loadSalesAttachment();
            },
            discussionSort: function () {
                var self = this;
                self.loadSalesPost();
            },
            savethedateSort: function () {
                var self = this;
                self.loadSaveTheDateDoc();
            },
        },
        created: function () {
            //console.log("here");
        },
        mounted: function () {
            var self = this;
            /*$(window).scroll(function () {
             if ($(this).scrollTop() > 100) {
             $('#scroll').fadeIn();
             } else {
             $('#scroll').fadeOut();
             }
             });*/
            $('#scroll').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });
            self.formTitle = 'Add Calender Entry';
            $("#list").hide();
            $("#backToCalendar").hide();

            $("#link").click(function () {
                $('#myModal').modal('toggle');
            });

            $(document).ready(function () {
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#EVcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#EVcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
            $("#discussionSearch").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.loadSalesPost();
                }
            });
            $("#attachmentSearch").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.loadSalesAttachment();
                }
            });
            $("#savetheDateSearch").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.loadSaveTheDateDoc();
                }
            });
            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
                self.loginUserID = userJson.id;
            } else {
                self.$router.push("/login");
            }
            self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
            self.contactEmail = userJson.email;
            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#description").on('keyup', function () {
                self.descriptionError = '';
            });
            $("#keydescription").on('keyup', function () {
                self.keydescriptionError = '';
            });
            $("#startDate").on('keyup', function () {
                self.startDateError = '';
            });
            $("#endDate").on('keyup', function () {
                self.endDateError = '';
            });
            $("#userId").on('keyup', function () {
                self.contactPersonError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            $("#status").change(function () {
                self.statusError = '';
            });
            $("#type").change(function () {
                self.typeError = '';
            });
            $("#recursiveType").change(function () {
                self.rectypeError = '';
            });
            $("#weekDays").change(function () {
                self.weekDaysError = '';
            });
            self.createdByTitle = 'Created By';
            $(".RecursiveType,.WeekDay").hide();
            $('.EndDate,.StartDate').show();
            self.getMenuSlug();

            $(self.$refs['videoPlayModal']).on("hidden.bs.modal", self.closeModalEvent);

        },

    methods: {
            
            closeModalEvent: function (e) {
                var self = this;
                var video = document.getElementById('video-container');
                video.pause();
            },

            setVideoFilePath: function (url) {
                var self = this;
                var video = document.getElementById('video-container');
                video.src = url;
                self.$refs['videoPlayModal'].show();
                video.play();
            },
            showGroupDiv(groupId){
                var self = this;
                //self.groupAttachmentsResult.forEach()
                for(var k in self.groupAttachmentsResult) {
                    let result = self.groupAttachmentsResult[k];
                    if(result.group_id == groupId){
                        self.selectedGroupAttachments.attachments = result.data;
                        self.selectedGroupAttachments.total_rows = result.total_rows;
                        self.selectedGroupAttachments.per_page = result.per_page;
                        self.selectedGroupAttachments.group_name = result.group_name;
                    }
                }
                console.log(self.selectedGroupAttachments);
                self.show_Group_Data = true;
                self.selectedAttachmentGroup = groupId;
                //selectedGroupAttachments
            },
            clickedBackFromChild(){
                var self = this;
                self.show_Group_Data = false;
            },
            loadAttachmentFromChild(){
                var self = this;
                self.loadSalesAttachment();
            },
            changeVisible(id) {
                var self = this;
                var activeKey = [];
                var tempArr = self.keysArr;
                self.keysArr = [];
                $.each(tempArr, function (i) {
                    if (id == tempArr[i].value) {
                        tempArr[i].is_view = (tempArr[i].is_view == 1) ? 0 : 1;
                    }
                    if (tempArr[i].is_view == 1) {
                        activeKey.push(tempArr[i].value);
                    }
                    self.keysArr.push(tempArr[i]);
                });
                self.$nextTick(function () {
                    self.display_events = [];
                    $.each(self.events, function (i) {
                        if ($.inArray(self.events[i].meeting_id, activeKey) != "-1") {
                            /*console.log(self.events[i].meeting_id);*/
                            self.display_events.push(self.events[i]);
                        }
                    });
                    /*console.log(self.display_events);*/
                    self.$refs.EVcalendar.$emit('refetch-events');
                });
            },
            buttonBack(viewID) {
                var self = this;
                self.swipViews = 0;
                self.scrollToTop();
                self.showMenu = true;
                if (viewID == 2) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    self.editEventID = 0;
                    self.removeAllFiles();
                    self.colorcode = '';
                    self.title = '';
                    self.description = '';
                    self.keydescription = '';
                    self.startDate = '';
                    self.endDate = '';
                    self.status = {value: 'active', text: 'Active'};
                    self.type = {value: 'normal', text: 'Normal'};
                    self.recursiveType = {value: 'monthly', text: 'Monthly'};
                    self.weekDays = {value: '1', text: 'Monday'};
                    self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                    self.contactEmail = userJson.email;
                    self.contactNumber = "";
                    self.imagesPaths = [];
                    self.imagesSize = [];
                    self.imagesType = [];
                    self.loadCalendarEvents();
                }
            },
            dayClick(date, jsEvent, view) {
                /*console.log(date);
                 console.log(jsEvent);
                 console.log(view);*/
            },
            searchBtnClick() {
                var self = this;
                $(".searchBtn").addClass("sb-search-open");
                $("#EVcalendar").hide();
                $("#refresh").hide();
                $(".nevCalendar").hide();
                $("#backToCalendar").show();
                $("#list").show();
                $(".keysContainer").hide();
                //e.stopPropagation();
            },
            backToCalendar() {
                var self = this;
                $(".searchBtn").removeClass("sb-search-open");
                $("#EVcalendar").show();
                $("#refresh").show();
                $(".nevCalendar").show();
                self.eventList = '';
                $("#backToCalendar").hide();
                $("#list").hide();
                $(".keysContainer").show();
                //e.stopPropagation();
            },
            eventSelected(event) {
                var self = this;
                self.selectedEvent = event;
                //console.log(self.selectedEvent);
            },
            showDetails() {
                var self = this;
                /*console.log(self.selectedEvent);
                 console.log(self.selectedEvent.title);*/
                self.swipViews = 1;
                self.scrollToTop();
            },
            previousMonth() {
                var self = this;
                self.$refs.EVcalendar.fireMethod('prev');
                self.startDateFrom = self.$refs.EVcalendar.fireMethod('getView').start.format();
                self.endDateTo = self.$refs.EVcalendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            nextMonth() {
                var self = this;
                self.$refs.EVcalendar.fireMethod('next');
                self.startDateFrom = self.$refs.EVcalendar.fireMethod('getView').start.format();
                self.endDateTo = self.$refs.EVcalendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            scrollToTop() {
                $('#scroll').click();
                /*$("html, body").animate({
                 scrollTop: 0
                 }, 600);
                 return true;*/
            },
            refreshEvents() {
                var self = this;
                var refresh = true;
                if (refresh) {
                    self.loadCalendarEvents();
                }
            },
            /* Load Meeting Type List Start*/
            loadMeetingType: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        'id': 0,
                        'status': 'active',
                    }
                };
                self.showLoader();
                HTTP.get("get_meeting_list", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.colorcodeArr = response.data.content;
                                if (response.data.content.length > 0) {
                                    self.colorcode = response.data.content[0];
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Load Meeting Type List End*/
            changedValueStatus: function () {
                self.statusError = "";
            },
            changedValueType: function () {
                self.typeError = "";
            },
            changedValueRecType: function () {
                self.rectypeError = "";
            },
            changedValueWeekDays: function () {
                self.weekDaysError = "";
            },
            onStartChange(selectedDates, dateStr, instance) {
                var self = this;
                self.$set(self.configEnd, 'minDate', dateStr);
            },
            onEndChange(selectedDates, dateStr, instance) {
                var self = this;
                self.$set(self.configStart, 'maxDate', dateStr);
            },
            changeDateFormat: function (dateTime) {
                var parts = dateTime.split(" ");
                var time = parts[1];
                var hours = Number(time.match(/^(\d+)/)[1]);
                var minutes = Number(time.match(/:(\d+)/)[1]);
                var AMPM = '';
                if (time.indexOf('PM') != -1) {
                    AMPM = 'PM';
                } else {
                    AMPM = 'AM';
                }
                if (AMPM == "PM" && hours < 12)
                    hours = hours + 12;
                if (AMPM == "AM" && hours == 12)
                    hours = hours - 12;
                var sHours = hours.toString();
                var sMinutes = minutes.toString();
                if (hours < 10)
                    sHours = "0" + sHours;
                if (minutes < 10)
                    sMinutes = "0" + sMinutes;
                return new Date(parts[0] + " " + sHours + ":" + sMinutes + ":00");
            },
            uploadDocument: function (file, response) {
                var self = this;
                //console.log(file);
                /* self.isFileUploaded = true; */
                self.imagesPaths.push(response.content);
                //console.log(self.imagesPaths);

                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                this.$refs.dropzone.setOption('maxFiles', null);
            },
            removedSelectedFile: function (file, xhr, error) {
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                this.$refs.dropzone.setOption('maxFiles', null);
                var self = this;
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* if (self.imagesPaths.length <= 0) {
                 self.isFileUploaded = false;
                 } */
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    this.$refs.dropzone.setOption('maxFiles', null);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    //console.log(removeFile);return false;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
                this.$refs.dropzone.setOption('maxFiles', null);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
            },
            removeFileFromServer: function (filePath) {
                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("profileColor");
                                    localStorage.removeItem("user_role");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
            },
            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* console.log("File Add"); */
            },
            uploadManually: function (file) {

                var self = this;
                for (var i = 0; i < self.loadDocArr.length; i++) {

                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    /*var file_type = self.getFileType(self.loadDocArr[i]['extension']);*/
                    var file_type = self.loadDocArr[i]['file_type'];
                    var file_size = self.loadDocArr[i]['size'];

                    self.imagesType.push(file_type);
                    self.imagesSize.push(Number(file_size));

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                }
                /* console.log("Accepted");
                 console.log(this.$refs.dropzone.getAcceptedFiles());
                 console.log("Rejected");
                 console.log(this.$refs.dropzone.getRejectedFiles()); */

                //this.$refs.dropzone.addRemoveLinks = true;

            },
            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                self.imagesPaths.push(String(orgPath + "/" + file_name));

                return file_name;
            },
            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                self.cropError = "";
                if (totaluploadprogress == 100) {
                    $("#CancelSocialMedia, #addSocialMediaBtn").prop('disabled', false);
                    /*console.log(totaluploadprogress);
                     console.log(totalBytes);
                     console.log(totalBytesSent);*/
                } else {
                    $("#CancelSocialMedia, #addSocialMediaBtn").prop('disabled', true);
                }
            },
            checkForm: function () {
                var self = this;
                var checked = true;
                var typ = (self.type === null || typeof self.type.value === "undefined" || self.type.value === null || self.type.value == '') ? '' : self.type.value;
                var recuTyp = (self.recursiveType === null || typeof self.recursiveType.value === "undefined" || self.recursiveType.value === null || self.recursiveType.value == '') ? '' : self.recursiveType.value;

                self.titleError = "";
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.title.length > 190) {
                    self.titleError = "Title cannot be longer than 190 character";
                    if (checked) {
                        checked = false;
                    }
                }
                /*self.keydescriptionError = "";
                 if (!self.keydescription) {
                 self.keydescriptionError = "Key Description Required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                /*self.descriptionError = "";
                 if (!self.description) {
                 self.descriptionError = "Description Required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                self.startDateError = "";
                if (typ == 'normal' || recuTyp == 'monthly' || recuTyp == 'yearly') {
                    if (!self.startDate) {
                        self.startDateError = "Start Date Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                self.contactPersonError = "";
                if (!self.userId && self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactPersonError = 'Please Enter Contact Person First';
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.userId && self.contactNumber && !String(self.contactNumber).match(/^[0-9]*$/)) {
                    self.contactPersonError = 'Please Enter Contact Person First';
                    self.contactNumberError = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length < 6) {
                    self.contactNumberError = "Phone Number Must Be Of Minimum 6 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.contactNumber && String(self.contactNumber).match(/^[0-9]*$/) && self.contactNumber.length > 18) {
                    self.contactNumberError = "Phone Number Must Be Of Maximum 18 Digits";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            addEvent() {
                var timedifference = new Date().getTimezoneOffset();
                var self = this;
                if (self.user_role == 1 || self.user_role == 2) {
                    if (self.checkForm()) {
                        var userJson = [];
                        var userObj = localStorage.getItem("user_obj");
                        if (userObj != null) {
                            userJson = JSON.parse(userObj);
                        } else {
                            self.$router.push("/login");
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")}
                        };

                        var start_date = '';
                        var end_date = '';
                        var recursive_type = '';
                        var day_of_week = '';
                        if (self.type.value == 'normal') {
                            start_date = self.startDate;
                            end_date = self.endDate;
                            recursive_type = '';
                            day_of_week = '';
                        } else {
                            recursive_type = self.recursiveType.value;
                            if (recursive_type == 'monthly' || recursive_type == 'yearly') {
                                start_date = self.startDate;
                                end_date = (self.endDate === null || self.endDate.trim() == '') ? '' : self.endDate;
                                day_of_week = '';
                            } else {
                                start_date = '';
                                end_date = '';
                                day_of_week = self.weekDays.value;
                            }
                        }
                        if (self.editEventID == 0) {
                            var data = {
                                colorcode: self.colorcode.value,
                                title: self.title,
                                imagePath: self.imagesPaths,
                                imageSize: self.imagesSize,
                                imageType: self.imagesType,
                                description: self.description,
                                keydescription: self.keydescription,
                                startDate: moment(start_date, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
                                endDate: moment(end_date, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
                                status: self.status.value,
                                type: self.type.value,
                                recursiveType: recursive_type,
                                weekDay: day_of_week,
                                contactPerson: self.userId,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                            };
                            $("#addSocialMediaBtn").val("Saving ...");
                        } else {
                            var data = {
                                colorcode: self.colorcode.value,
                                title: self.title,
                                imagePath: self.imagesPaths,
                                imageSize: self.imagesSize,
                                imageType: self.imagesType,
                                description: self.description,
                                keydescription: self.keydescription,
                                startDate: moment(start_date, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
                                endDate: moment(end_date, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
                                status: self.status.value,
                                type: self.type.value,
                                recursiveType: recursive_type,
                                weekDay: day_of_week,
                                contactPerson: self.userId,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                                id: self.editEventID,
                            };
                            $("#addSocialMediaBtn").val("Updating ...");
                        }
                        /*console.log(JSON.stringify(data));
                         return false;*/
                        $("#addSocialMediaBtn").prop("disabled", true);
                        $("#CancelSocialMedia").prop("disabled", true);
                        self.showLoader();
                        HTTP.post("addupdateevent", data, config)
                                .then(function (response) {
                                    self.removeAllFiles();
                                    if (self.editEventID == 0) {
                                        $("#addSocialMediaBtn").val("Save");
                                    } else {
                                        $("#addSocialMediaBtn").val("Update");
                                    }
                                    $("#addSocialMediaBtn").prop("disabled", false);
                                    $("#CancelSocialMedia").prop("disabled", false);
                                    if (response.data.message == "success") {
                                        self.showSAlert(response.data.content, 'success');
                                        self.colorcode = '';
                                        self.title = '';
                                        self.description = '';
                                        self.keydescription = '';
                                        self.startDate = '';
                                        self.endDate = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.type = {value: 'normal', text: 'Normal'};
                                        self.recursiveType = {value: 'monthly', text: 'Monthly'};
                                        self.weekDays = {value: '1', text: 'Monday'};
                                        self.createdBy = self.userId = userJson.first_name + " " + userJson.last_name;
                                        self.contactEmail = userJson.email;
                                        self.contactNumber = "";
                                        self.imagesPaths = [];
                                        self.imagesSize = [];
                                        self.imagesType = [];
                                        setTimeout(function () {
                                            self.buttonBack(2);
                                        }, 3000);
                                        self.loadMeetingType();
                                    } else {
                                        if (response.data.content.length > 0) {
                                            var err = "";
                                            for (var i = 0; i < response.data.content.length; i++) {
                                                err += response.data.content[i] + "<br>";
                                            }
                                            self.showSAlert(err, 'error');
                                        }
                                        setTimeout(function () {
                                            self.buttonBack(2);
                                        }, 5000);
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.removeAllFiles();
                                    if (self.editEventID == 0) {
                                        $("#addSocialMediaBtn").val("Save");
                                    } else {
                                        $("#addSocialMediaBtn").val("Update");
                                    }
                                    $("#addSocialMediaBtn").prop("disabled", false);
                                    $("#CancelSocialMedia").prop("disabled", false);
                                    self.catchHandler(err, function () {});
                                    self.hideLoader();
                                });

                    }
                }
            },
            getDayName(id) {
                var self = this;
                $.each(self.weekDaysArr, function (i) {
                    if (self.weekDaysArr[i].value == id) {
                        console.log(JSON.stringify(self.weekDaysArr[i]));
                        return {"text": self.weekDaysArr[i].text, "value": self.weekDaysArr[i].value};
                    }
                });
            },
            loadCalendarEvents() {
                var self = this;
                var timedifference = new Date().getTimezoneOffset();
                var startdate = (self.startDateFrom === null || typeof self.startDateFrom === "undefined") ? 0 : self.startDateFrom;
                var endDateTo = (self.endDateTo === null || typeof self.endDateTo === "undefined") ? 0 : self.endDateTo;
                if (startdate == 0 || endDateTo == 0) {
                    startdate = moment(new Date(), "YYYY-MM-DD HH:mm:ss").add(-30, 'days').add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                    endDateTo = moment(new Date(), "YYYY-MM-DD HH:mm:ss").add(+30, 'days').add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                } else {
                    startdate = moment(startdate, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                    endDateTo = moment(endDateTo, "YYYY-MM-DD HH:mm:ss").add(+1, 'days').add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                }
                self.selectedEvent = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        start_date: startdate,
                        end_date: endDateTo,
                        offset_minutes: timedifference,
                        id: self.detailFromEmailId,
                    }
                };
                self.showLoader();
                HTTP.get("getevents", config)
                        .then(function (response) {
                            self.events = self.display_events = response.data.content.events;
                            self.keysArr = [];
                            $.each(response.data.content.keys, function (i) {
                                response.data.content.keys[i].is_view = 1;
                                self.keysArr.push(response.data.content.keys[i]);
                            });
                            self.$refs.EVcalendar.$emit('refetch-events');
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                //self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("profileColor");
                                    localStorage.removeItem("user_role");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                //self.error = err.response.data.message;
                            }
                        });
            },
            loadEvent(id) {
                var self = this;
                $.each(self.eventList, function (i) {
                    if (self.eventList[i].id == id) {
                        self.selectedEvent = self.eventList[i];
                    }
                });
                self.showDetails();
            },
            searchEvent() {
                var self = this;
                var timedifference = new Date().getTimezoneOffset();
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        params: {
                            search: self.searchEvents,
                            offset_minutes: timedifference,
                        }
                    };
                    HTTP.get("getevents", config)
                            .then(function (response) {
                                self.eventList = response.data.content.events;
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("token");
                                        localStorage.removeItem("profileColor");
                                        localStorage.removeItem("user_role");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                }
            },
            deleteEvents: function (id) {
                var self = this;
                var eventArr = [];
                eventArr.push(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    data: {
                        deleteArr: eventArr,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deleteevents", config)
                                .then(function (response) {
                                    self.buttonBack(2);
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("token");
                                            localStorage.removeItem("profileColor");
                                            localStorage.removeItem("user_role");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            self.$swal('Cancelled', err.response.data.content, 'info');
                                            self.buttonBack(2);
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record still intact', 'info')
                    }
                })
            },
            editEvent(eventID) {
                var self = this;
                self.editEventID = eventID;
                /*self.createdByTitle = 'Last Updated By';*/
                self.createdByTitle = 'Updated By';
                self.formTitle = 'Edit Calender Entry';
                self.loadEventEdit();
                $("#addSocialMediaBtn").val("Update");
                self.scrollToTop();
            },
            loadEventEdit() {
                var self = this;
                var timedifference = new Date().getTimezoneOffset();
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.editEventID,
                        offset_minutes: timedifference,
                    }
                };
                HTTP.get("getevent", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.colorcode = {value: response.data.content.events[0].meeting_id, text: response.data.content.events[0].mm_title};
                                self.title = response.data.content.events[0].title;
                                self.description = response.data.content.events[0].description;
                                self.keydescription = response.data.content.events[0].key_description;
                                self.contactEmail = response.data.content.events[0].contact_email;
                                self.contactNumber = response.data.content.events[0].contact_number;
                                var userJson = [];
                                var userObj = localStorage.getItem("user_obj");
                                if (userObj != null) {
                                    userJson = JSON.parse(userObj);
                                } else {
                                    self.$router.push("/login");
                                }
                                self.userId = self.createdBy = userJson.first_name + " " + userJson.last_name;
                                self.loadDocArr = response.data.content.events[0].attachments;
                                self.status = {value: response.data.content.events[0].status, text: self.formatString(response.data.content.events[0].status)};
                                self.type = {value: response.data.content.events[0].type, text: self.formatString(response.data.content.events[0].type)};
                                if (response.data.content.events[0].recursive_type === null || typeof response.data.content.events[0].recursive_type === "undefined") {
                                } else {
                                    self.recursiveType = {value: response.data.content.events[0].recursive_type, text: self.formatString(response.data.content.events[0].recursive_type)};
                                }
                                if (response.data.content.events[0].day_of_week === null || typeof response.data.content.events[0].day_of_week === "undefined") {
                                } else {
                                    $.each(self.weekDaysArr, function (i) {
                                        if (self.weekDaysArr[i].value == response.data.content.events[0].day_of_week) {
                                            self.weekDays = self.weekDaysArr[i];
                                        }
                                    });
                                }
                                self.uploadManually();
                                if (response.data.content.events[0].start_date === null || typeof response.data.content.events[0].start_date === "undefined") {
                                } else {
                                    self.startDate = response.data.content.events[0].start_date;
                                }
                                if (response.data.content.events[0].end_date === null || typeof response.data.content.events[0].end_date === "undefined") {
                                } else {
                                    self.endDate = response.data.content.events[0].end_date;
                                }
                            } else {
                                self.$swal('Cancelled', response.data.message, 'info');
                                self.buttonBack(2);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("profileColor");
                                    localStorage.removeItem("user_role");
                                    self.$router.push("/login");
                                } else {
                                    self.$swal('Cancelled', err.response.data.message, 'info');
                                    self.buttonBack(2);
                                }
                                self.error = err.response.data.message;
                            }
                        });
                self.swipViews = 2;
            },
            downloadAllAttachments(id) {
                var self = this;
                /*console.log(id);*/
                $("#DownloadAll").prop("disabled", true);
                $("#DownloadAll").html("Preparing File...");
                if (id) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        params: {id: id}
                    };
                    /*console.log(config);*/
                    HTTP.get("downloadattachment", config)
                            .then(function (response) {
                                /*console.log(id);*/
                                self.downloadImage(response.data.content.zip_file);
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                            })
                            .catch(function (err) {
                                $("#DownloadAll").prop("disabled", false);
                                $("#DownloadAll").html("Download All");
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("token");
                                        localStorage.removeItem("profileColor");
                                        localStorage.removeItem("user_role");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    } else {
                                        self.$swal('Cancelled', err.response.data.message, 'info');
                                        self.buttonBack(2);
                                    }
                                }
                            });
                }
            },
            downloadImage: function (filepath) {
                //console.log(filepath);
                window.open(filepath, 'Download');
                //window.location.assign(self.viewImage);
                /*location.href = self.viewImage;*/
            },
            toSlide: function () {
                var self = this;
                $.each(self.$store.getters.menuArr, function (key, value) {
                    if (typeof (value.sub_menu) != 'undefined') {
                        if (value.sub_menu.length > 0) {
                            $.each(value.sub_menu, function (key_sub, value_sub) {
                                if (self.menuSlug == value_sub.slug) {
                                    /* console.log(self.$refs); */
                                    self.$refs.mySwiper[0].swiper.slideTo(value_sub.slide_id, 0);
                                    /* $('#mySwiper').slideTo(value_sub.slide_id, 0); */
                                }
                            });
                        }
                    }
                });
            },
            viewDetails: function (id) {
                var self = this;
                localStorage.setItem("post_id", id);
                self.$router.push({name: 'CommonPostDetail', params: {type: self.menuSlug}});
            },
            //common call methods to get slug and change route in watch and mounted method.
            getMenuSlug: function () {
                var self = this;

                self.showLoader();
                self.menuSlug = this.$route.params.type;
                self.getMenuDetails(self.menuSlug);
                //self.getRole();

                /*if (self.menuSlug != 'save-the-date') {*/
                self.loadSalesPost();
                self.loadSalesAttachment();
                /*} else {*/
                self.loadSaveTheDateDoc();
                /*}*/
                localStorage.removeItem("post_id");

                /* Get Role for conditionally provide add/edit feature */
                /*
                 setTimeout(function () {
                 self.getMenuDetails(self.menuSlug);
                 self.user_role = localStorage.getItem("user_role");
                 }, 300);
                 */

                /* self.$store.dispatch('loadMenu'); */
                /* for(var index = 0;index<self.$store.getters.menuArr;index++){
                 if ($store.getters.menuArr[index].sub_menu.length > 0) {
                 self.is_SubMenu = true;
                 }else{
                 self.is_SubMenu = false;
                 }
                 } */
                /*HTTP.interceptors.request.use(request => {
                 console.log('Starting Request', JSON.stringify(request));
                 return request;
                 });
                 HTTP.interceptors.response.use(response => {
                 console.log('Response:', response);
                 return response;
                 });*/
                //this.$store.commit('changePastTab', '');
                /*setTimeout(function () {
                 self.toSlide();
                 }, 1000);*/
                this.$nextTick(function () {
                    self.toSlide();
                });
            },

            /* Display Save the date Start*/
            loadSaveTheDateDoc: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        'slug': self.menuSlug,
                        'page': self.saveTheDateCurrentPage,
                        'filter': self.saveDateSearch,
                        'sort': self.savethedateSort.value,
                    }
                };
                self.showLoader();
                HTTP.get("display_save_date_post", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.saveTheDateData = response.data.content;
                                if (response.data.content.length <= 0) {
                                    self.saveTheDateCurrentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Display Save the date End*/
            /* Display Sales Post Start*/
            loadSalesPost: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        'slug': self.menuSlug,
                        'page': self.discussionCurrentPage,
                        'filter': self.discussionSearch,
                        'sort': self.discussionSort.value,
                    }
                };
                self.showLoader();
                HTTP.get("display_sales_post", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.discussionData = response.data.content;
                                if (response.data.content.length <= 0) {
                                    self.discussionCurrentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Display Sales Post End*/
            /* Display Sales Attachments Start*/
            loadSalesAttachment: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        'slug': self.menuSlug,
                        'page': self.attachmentCurrentPage,
                        'filter': self.attachmentSearch,
                        'sort': self.attachmentSort.value,
                    }
                };
                self.showLoader();
                HTTP.get("display_sales_attachment", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.attachmentData = response.data.content;
                                self.groupAttachmentsResult = response.data.content.groupAttachmentsResult;
                                if (response.data.content.length <= 0) {
                                    self.attachmentCurrentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Display Sales Attachments End*/

            deleteDiscussion: function (salesId, deleteFlag) {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    data: {
                        'salesId': salesId,
                        'salest_type': deleteFlag
                    }
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.delete("delete_sales_data", config)
                                .then(function (response) {
                                    if (response.data.code == '200') {
                                        self.$swal({
                                            title: self.formatString(deleteFlag) + " Deleted successfully",
                                            text: "",
                                            type: "success",
                                        });
                                        self.loadSalesPost();
                                        self.loadSalesAttachment();
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });
            },

            deleteEvent: function (eventId) {

                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    data: {
                        'eventId': eventId,
                    }
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.delete("delete_save_date_data", config)
                                .then(function (response) {
                                    if (response.data.code == '200') {
                                        self.$swal({
                                            title: "Deleted successfully",
                                            text: "",
                                            type: "success",
                                        });
                                        self.loadSaveTheDateDoc();
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });
            },

            storePostComment: function (post_id) {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var error = false;
                self.comment_err_msg = "";

                if (self.commentData == null || self.commentData == "") {
                    self.comment_err_msg = "The Comment is Required.";
                    error = true;
                }

                var config = {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                };
                var fields = {
                    'comment': self.commentData,
                    'sales_id': post_id
                };

                if (!error) {
                    self.showLoader();
                    HTTP.post('store_comment', fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {

                                    self.commentData = "";
                                    //self.loadSalesPost();

                                    //$('#cid'+post_id).load();
                                    $('#cid' + post_id).html();
                                    for (var index = 0; index < response.data.content; index++) {
                                        $('#cid' + post_id).text(response.data.content[inex].comment);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                }
            },

            /* display single or multiple grid wise data */
            gridChange: function (gridFlag) {

                var self = this;
                if (gridFlag != "single") {
                    self.is_Grid = false;
                } else {
                    self.is_Grid = true;
                }
            },

            /* display user name in formated string */
            formatString: function (data) {
                data = (data === null || typeof data === "undefined") ? '' : data;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            /*get user's initials from firstname lastname */
            getInitials: function (string) {
                var names = string.split(' ');
                var initials = "";
                $.each(names, function (i) {
                    initials += names[i].charAt(0);
                });
                return initials.toUpperCase();
            },
            /* Get images for gallery view */
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                $.each(documents, function (i) {
                    if (jQuery.inArray(documents[i].doc_extension.toLowerCase(), exten) !== -1) {
                        if (i == index) {
                            index = new_index;
                        }
                        /* arr.push({
                         'thumb': documents[i].document,
                         'src': documents[i].document,
                         'caption': '',
                         }); */
                        arr.push(documents[i].document);
                        new_index = new_index + 1;
                    }
                });
                self.loadImagesInLightBox(arr, index);
            },
            onCancel: function (type) {
                /*console.log("Close images view");*/
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.viewImage = self.lightboxImages[self.index];
            },
            /* set images to gallery view */
            loadImagesInLightBox: function (arr, index) {
                var self = this;
                self.lightboxImages = arr;
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                self.$refs.myModalRef.show();
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/CommonPage.vue